(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.HPQuizApi = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var TOKEN_PREFIX = 'hp_quiz_access:v1:';
  var SAVE_PREFIX = 'hp_quiz_save:v1:';

  function ApiError(code, status, retryable) {
    this.name = 'HPQuizApiError';
    this.code = code || 'quiz_network_error';
    this.status = status || 0;
    this.retryable = !!retryable;
    this.message = this.code;
  }
  ApiError.prototype = Object.create(Error.prototype);

  function safeJson(response) {
    return response.json().catch(function () { return {}; });
  }

  function createClient(options) {
    var baseUrl = String(options.baseUrl || '').replace(/\/+$/, '');
    var fetchImpl = options.fetchImpl;
    var timeoutMs = options.timeoutMs || 8000;
    if (!/^https:\/\//.test(baseUrl) || typeof fetchImpl !== 'function') return null;

    function request(path, body, token) {
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = controller ? setTimeout(function () { controller.abort(); }, timeoutMs) : null;
      var headers = { 'content-type': 'application/json' };
      if (token) headers.authorization = 'Bearer ' + token;
      return fetchImpl(baseUrl + path, {
        method: 'POST', headers: headers, body: JSON.stringify(body || {}),
        signal: controller ? controller.signal : undefined
      }).then(function (response) {
        return safeJson(response).then(function (payload) {
          if (!response.ok) {
            var code = payload && payload.error && payload.error.code;
            throw new ApiError(code || 'quiz_http_error', response.status,
              response.status === 0 || response.status === 408 || response.status === 429 || response.status >= 500);
          }
          return payload;
        });
      }).catch(function (error) {
        if (error instanceof ApiError) throw error;
        throw new ApiError(error && error.name === 'AbortError' ? 'quiz_timeout' : 'quiz_network_error', 0, true);
      }).finally(function () { if (timer) clearTimeout(timer); });
    }

    return {
      bootstrap: function (input) { return request('/api/v1/quiz/bootstrap', input); },
      status: function (token) { return request('/api/v1/quiz/status', {}, token); },
      save: function (token, input) { return request('/api/v1/quiz/salvar', input, token); }
    };
  }

  function storageKey(prefix, environment, product) {
    return prefix + String(environment || 'preview') + ':' + String(product || 'unknown');
  }

  function createSession(options) {
    var storage = options.storage;
    var environment = options.environment;
    var product = options.product;
    var orderReference = String(options.orderReference || '');
    function read(prefix) {
      try { return storage ? storage.getItem(storageKey(prefix, environment, product)) : null; } catch (_) { return null; }
    }
    function write(prefix, value) {
      if (!storage) return;
      try { storage.setItem(storageKey(prefix, environment, product), value); } catch (_) { /* memória apenas */ }
    }
    function remove(prefix) {
      if (!storage) return;
      try { storage.removeItem(storageKey(prefix, environment, product)); } catch (_) { /* memória apenas */ }
    }
    return {
      token: function () {
        var raw = read(TOKEN_PREFIX);
        if (!raw) return null;
        try {
          var saved = JSON.parse(raw);
          return (!orderReference || saved.orderReference === orderReference) ? saved.token : null;
        } catch (_) { return null; }
      },
      setToken: function (token) { write(TOKEN_PREFIX, JSON.stringify({ token: token, orderReference: orderReference })); },
      clearToken: function () { remove(TOKEN_PREFIX); },
      idempotency: function (randomUUID) {
        var existing = read(SAVE_PREFIX);
        if (existing && /^[0-9a-f-]{36}$/i.test(existing)) return existing;
        var created = randomUUID();
        write(SAVE_PREFIX, created);
        return created;
      },
      clearIdempotency: function () { remove(SAVE_PREFIX); }
    };
  }

  function publicError(error) {
    if (!error) return 'Não conseguimos sincronizar agora.';
    if (error.code === 'quiz_timeout') return 'A sincronização demorou mais que o esperado.';
    if (error.status === 401 || error.code === 'quiz_unauthorized') return 'Este link expirou. Abra novamente o link recebido no e-mail.';
    if (error.status === 409 || error.code === 'quiz_stale_revision') return 'Seu plano foi atualizado em outro acesso. Sincronize antes de tentar novamente.';
    return 'Não conseguimos sincronizar agora. Tente novamente.';
  }

  return { ApiError: ApiError, createClient: createClient, createSession: createSession, publicError: publicError };
});
